var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.775 5.23417C16.4175 4.87667 15.84 4.87667 15.4825 5.23417L11 9.7075L6.5175 5.225C6.16 4.8675 5.5825 4.8675 5.225 5.225C4.8675 5.5825 4.8675 6.16 5.225 6.5175L9.7075 11L5.225 15.4825C4.8675 15.84 4.8675 16.4175 5.225 16.775C5.5825 17.1325 6.16 17.1325 6.5175 16.775L11 12.2925L15.4825 16.775C15.84 17.1325 16.4175 17.1325 16.775 16.775C17.1325 16.4175 17.1325 15.84 16.775 15.4825L12.2925 11L16.775 6.5175C17.1233 6.16917 17.1233 5.5825 16.775 5.23417Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/CancelIcon.51a6139f019f5c1965570948c646ff7b.svg";
export { ForwardRef as ReactComponent };